/**
 * Etiqueta "Popular" — pill blanco con texto morado para marcar productos
 * destacados. Usado en BusinessCard, Food y ProductDetailSheet.
 *
 * El consumer aplica posicionamiento via `className` (ej. "absolute top-1
 * left-1.5"). Opcional `shadow` para sombra sutil (algunas variantes la
 * usaban) y `size` para variantes de tamaño:
 *   - 'sm' (default): text-[13px] px-2 py-0.5
 *   - 'lg': text-base px-3 py-0.5 (usado en ProductDetailSheet)
 */
export default function PopularTag({ size = 'sm', shadow = false, className = '' }) {
  const sizeCls = size === 'lg'
    ? 'text-base px-3 py-0.5'
    : 'text-[13px] px-2 py-0.5';
  const shadowCls = shadow ? 'shadow-sm' : '';

  return (
    <div className={`bg-businesscard-popular-tag-bg font-semibold text-businesscard-popular-tag-text rounded-full ${sizeCls} ${shadowCls} ${className}`}>
      Popular
    </div>
  );
}
